import { Component } from '@angular/core';
import { SampleService } from '../shared/sample.service';

@Component({
  template: `
    <section>
    <div class="container">
      <div class="row">
        <h4>{{test}}</h4>
        <p>{{text}}</p> 
      </div> 
    </div>
    </section>
  `,
  providers: [SampleService]
})
export class BrowserComponent {
  test = 'Rendered by the browser';
  text: string;

  constructor(private service: SampleService) {
    this.text = service.go();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/browser.component.ts